// Special characters allowed in passwords (character class only)
const SPECIAL_CHARS_CLASS = '[-+_!@#$%^&*.,?]';

export const SPECIAL_CHARS_REGEX = new RegExp(`^(?=.*${SPECIAL_CHARS_CLASS}).+$`);

export function isNumber(value: string): boolean {
  return new RegExp('^(?=.*[0-9]).+$').test(value);
}

export function isLowercaseChar(value: string): boolean {
  return new RegExp('^(?=.*[a-z]).+$').test(value);
}

export function isUppercaseChar(value: string): boolean {
  return new RegExp('^(?=.*[A-Z]).+$').test(value);
}

export function isSpecialChar(value: string): boolean {
  return SPECIAL_CHARS_REGEX.test(value);
}

export function minLength12(value: string): boolean {
  return value.length >= 12;
}

export function hasNoSpaces(value: string): boolean {
  return !/\s/.test(value);
}
